<template>
  <v-card class="mx-auto" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col cols="12" md="8">
          <BtnCircle
            tLabel="Atrás"
            tPosition="bottom"
            icon="mdi-arrow-left"
            color="grey darken-3"
            size="x-small"
            :to="{ name: 'contratantes' }"
          />
          <span
            class="text-h6 ml-1"
            v-text="
              `${$route.meta.title} ${loading ? '' : `(${data_table.length})`}`
            "
          />
        </v-col>
        <v-col cols="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="info"
                @click.stop="faqs_dlg = true"
                :loading="faqs_ldg"
                :disabled="faqs.length == 0"
              >
                <v-icon> mdi-help </v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>
          <BtnCircle
            v-if="true"
            tLabel="Agregar"
            tPosition="bottom"
            icon="mdi-plus"
            color="success"
            size="x-small"
            :to="{ name: `${page_route}.agregar` }"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="data_table"
            :search="search"
            :loading="loading"
            dense
          >
            <template v-slot:item.index="{ index }">
              <b>{{ index + 1 }}</b>
            </template>
            <template v-slot:item.consolidated="{ item }">
              <v-icon small :color="item.consolidated ? 'info' : ''">
                mdi-circle
              </v-icon>
            </template>
            <template v-slot:item.add_general="{ item }">
              <v-icon small :color="item.add_general ? 'info' : ''">
                mdi-circle
              </v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="info"
                    :to="{
                      name: `${page_route}.detalle`,
                      params: { id: item.id },
                    }"
                  >
                    <v-icon small> mdi-eye </v-icon>
                  </v-btn>
                </template>
                <span v-text="'Ver'" />
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";
import { URL_API, headersToken } from "../../control";
import { index } from "../../requests/pageRequest";
import BtnCircle from "../../components/BtnCircle.vue";
import FaqDlg from "../../components/FaqDlg.vue";

export default {
  components: {
    BtnCircle,
    FaqDlg,
  },
  data() {
    return {
      page_route: "contratantes.concentradores",
      login: this.$store.getters.getLogin,
      loading: true,
      data_table: [],
      search: "",
      headers: [
        {
          text: "#",
          value: "index",
          sortable: false,
          filterable: false,
          width: "60px",
        },
        {
          text: "Nombre",
          value: "contractor_brand",
        },
        {
          text: "Consolidado",
          value: "consolidated",
        },
        {
          text: "O. P. Sumatoria a general",
          value: "add_general",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          filterable: false,
          width: "60px",
        },
      ],
      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
    };
  },
  mounted() {
    Axios.get(
      URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
      headersToken(this.login.token)
    ).then((resp) => {
      this.faqs = resp.data.data;
      this.faqs_ldg = false;
    });

    index("contractors/brands", this.login.token, []).then((response) => {
      this.data_table = response.data;
      this.loading = false;
    });
  },
};
</script>